import styled from "styled-components";

export const Wrapper = styled.div`
  .heading {
    text-align: center;
    text-transform: uppercase;
    font-size: 20px;
    font-weight: bold;
  }
  .position-holders {
    display: flex;
    justify-content: space-evenly;
    align-items: flex-end;
    padding: 0px 300px;
    .position-holder-numbers {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .ranker-name {
        text-align: center;
        margin-top: -13px;
        width: 100%;

        h4 {
          font-size: 17px;
          font-weight: bold;
          text-transform: uppercase;
          text-align: center;
          margin: auto;
          margin-bottom: 3px;
        }
        h5 {
          font-size: 12px;
          font-style: normal;
        }
        h6 {
          color: #4287a3;
          font-weight: 600;
        }
      }
      span {
        background-color: #fff;
        font-size: 1.3em;
        border: 4px solid lightblue;
        border-radius: 50%;
        width: 35px;
        height: 35px;
        text-align: center;
        position: relative;
        top: -20px;
      }
      .sales-gold {
        color: #f5d114;
        font-size: 28px;
        font-weight: 600;
        margin: auto;
      }
      .sale {
        color: #f5d114;
        margin: auto;
        font-size: 20px;
      }
      .sales-color {
        color: #4287a3;
        font-size: 20px;
        font-weight: 600;
        margin: auto;
      }
      .holder-one {
        border: 4px solid gold;
        color: black;
        background-color: #fff;
        font-size: 1.3em;
        border-radius: 50%;
        width: 35px;
        height: 35px;
        text-align: center;
        position: relative;
        top: -20px;
      }
      .holder-two {
        border: 3px solid #4287a3;
        background-color: #fff;
        font-size: 1.3em;
        border-radius: 50%;
        width: 35px;
        height: 35px;
        text-align: center;
        position: relative;
        top: -20px;
      }
    }
    ._2nd-position-holder {
      border-radius: 50%;
      border: 4px solid lightblue;
      width: 120px;
      height: 120px;
      object-fit: cover;
    }
    ._1nd-position-holder {
      border-radius: 50%;
      border: 4px solid gold;
      width: 160px;
      height: 160px;
      object-fit: cover;
    }
  }
  @media only screen and (max-width: 565px) {
    .position-holders {
      padding: 0px 120px;
    }
  }
  @media only screen and (max-width: 500px) {
    ._1nd-position-holder {
      width: 120px !important;
      height: 120px !important;
    }
    ._2nd-position-holder {
      width: 100px !important;
      height: 100px !important;
    }
  }

  /* positons table container start  */

  .positions-table-container {
    width: 100%;
  }
  .border-line {
    border: 2px solid darkgray;
    width: 100%;
    border-radius: 50px 50px;
    margin-top: 10px;
  }
  .button-text {
    margin-top: 10px;
    display: flex;
    justify-content: space-evenly;
  }
  .time-button {
    text-align: center;
    width: 150px;

    h5 {
      font-weight: 500;
      font-family: sans-serif;
    }
    button {
      font-weight: bold;
      background-color: black;
    }
  }
  .office-button {
    text-align: center;
    width: 150px;

    h5 {
      font-weight: 500;
      font-family: sans-serif;
    }
    Button {
      font-weight: bold;
      background-color: black;
    }
  }
  .ranking-list-main {
    margin-top: 10px;
  }
  .rank-section {
    align-items: center;
    border-radius: 10px;
    /* box-shadow: 0px 1px 2px 1px cornflowerblue; */

    margin-top: 5px;
    margin-bottom: 10px;
  }
  .rank-title {
    display: flex;
    justify-content: center;
    font-size: 18px;
    font-weight: 500;
    border: 2px gray;
    padding: 5px;
  }
  .ranker-image {
    display: flex;
    align-items: center;
    margin-left: 45px;
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 1px solid #fff;
      margin-left: 15px;
      object-fit: cover;
    }
  }
  .ranker-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    h5 {
      margin: 0%;
    }
    span {
      font-size: 12px;
    }
  }
  @media only screen and (max-width: 470px) {
    .rank-title {
      span {
        font-size: 13px;
        font-weight: 600;
      }
    }

    .ranker-image {
      span {
        font-size: 13px;
        font-weight: 600;
      }
    }
    .ranker-info {
      h5 {
        margin: 0%;
        font-size: 13px;
        font-weight: 600;
      }
      span {
        font-size: 12px;
      }
    }
  }
  @media only screen and (max-width: 500px) {
    .ranker-name {
      h4 {
        font-size: 12px !important;
      }
    }
    .sales-gold {
      font-size: 22px !important;
    }
    .time-button {
      h5 {
        font-size: 16px !important;
        font-weight: 600 !important;
      }
      button {
        width: 100px !important;
      }
    }
    .office-button {
      h5 {
        font-size: 16px !important;
        font-weight: 600 !important;
      }
      button {
        width: 100px !important;
      }
    }
  }
  @media only screen and (max-width: 445px) {
    .ranker-image {
      margin-left: 10px !important;
      img {
        margin-left: 15px !important;
        width: 30px !important;
      height: 30px !important;
      }
    }
  }
`;
